const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            avaiable:           'Disponível até',
            cancel:             'Cancelar',
            close:              'Fechar',
            content:            'Galeria',
            content_add:        'Adicionar bloco',
            content_edit:       'Editar galeria',
            content_new:        'Nova galeria',
            content_list:       'Lista de galerias',
            dates:              'Datas',
            date_creation:      'Criação',
            date_avaiable:      'Disponível até',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            draft:              'Rascunho',
            doc_choose:         'Escolher PDF',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Procurar',
            id:                 'ID',
            layout:             'Tipo',
            multimedia:         'Multimédia',
            name:               'Nome',
            name_placeholder:   'Introduza o nome',
            image:              'Imagem de destaque',
            images:             'Imagens',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            page_config:        'Configuração da Página',
            page_parent:        'Parent',
            pages:              'Páginas',
            pdf_documents:      'Documentos PDF',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remover',
            schedule:           'Agendar',
            schedule_to:        'Agendado',
            seo_config:         'Configuração SEO',
            seo_description:    'Descrição SEO',
            seo_description_placeholder: 'Introduza a descrição SEO',
            seo_keywords:       'Keywords SEO',
            seo_keywords_small: '(separar por virgula)',
            seo_keywords_placeholder: 'Introduza as keywords SEO',
            seo_title:          'Título SEO',
            seo_title_placeholder: 'Introduza o título SEO',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_date_published: 'Data de Publicação',
            table_date_modified: 'Data de alteração',
            table_state:        'Estado',
            table_actions:      'Acções',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n' ,
            upload_image_length_error : 'Apenas pode carregar 10 imagens de cada vez.',
            save:               'Salvar',        
            subtitle:           'Subtítulo',
            subtitle_placeholder:  'Introduza o subtítulo',   
            youtube_choose:      'Youtube',          
        },
    'en':
        {
            add_new:            'Add new',
            avaiable:           'Avaiable until',
            cancel:             'Cancel',
            close:              'Close',
            content:            'Gallery',
            content_add:        'Add block',
            content_edit:       'Edit gallery',
            content_new:        'New gallery',
            content_list:       'Gallery list',
            dates:              'Dates',
            date_creation:      'Creation',
            date_avaiable:      'Avaiable until',
            date_publication:   'Publication',
            date_last_update:   'Last update',
            delete:             'Delete',
            delete_title:       'Delete Regist',
            delete_text:        'Are you sure you want to continue?',
            delete_confirm:     'Yes',
            delete_cancel:      'No',
            delete_error:       'Problem deleting the element!',
            delete_success:     'Element deleted successfully!',
            description:        'Description',
            draft:              'Draft',
            doc_choose:         'Choose PDF',
            edit:               'Edit',
            edit_title:         'Edit Regist',
            edit_text:          'Are you sure you want to continue?',
            edit_confirm:       'Yes',
            edit_cancel:        'No',
            edit_error:         'Problem updating element!',
            edit_success:       'Successful updated element!',
            file_attach:        'Attach file',
            file_remove_all:    'Remove all',
            file_upload:        'Upload file',
            file_upload_all:    'Upload all',
            filter_placeholder: 'Search',
            id:                 'ID',
            layout:             'Type',
            multimedia:         'Multimedia',
            name:               'Name',
            name_placeholder:   'Insert the name',
            image:              'Highlight image',
            images:             'Images',
            image_choose:       'Choose image',
            insert_title:       'New Regist',
            insert_text:        'Are you sure you want to continue?',
            insert_confirm:     'Yes',
            insert_cancel:      'No',
            insert_error:       'Problem updating element!',
            insert_success:     'Successful updated element!',
            page_config:        'Page config',
            page_parent:        'Parent',
            pages:              'Pages',
            pdf_documents:      'PDF Documents',
            principal:          'Principal',
            published:          'Publicado',
            remove:             'Remove',
            schedule:           'Schedule',            
            schedule_to:        'Schedule', 
            seo_config:         'SEO config',
            seo_description:    'SEO description',
            seo_description_placeholder: 'Insert the SEO description',
            seo_keywords:       'SEO keywords',
            seo_keywords_small: '(separate by comma)',
            seo_keywords_placeholder: 'Insert the SEO keywords',
            seo_title:          'SEO title',
            seo_title_placeholder: 'Insert the SEO title',
            table_rows_per_page:'Regist by page:',
            table_separator:    'of',
            table_all:          'All',
            table_title:        'Title',
            table_parent:       'Parent',
            table_date:         'Date',
            table_date_published: 'Published date',
            table_date_modified: 'Modified date',
            table_state:        'State',
            table_actions:      'Actions',
            text:               'Text',
            title:              'Title',
            title_placeholder:  'Insert title',
            save:               'Save',
            subtitle:           'Subtitle',
            subtitle_placeholder:  'Insert subtitle',  
            upload_image_error : 'Only jpg, jpeg and png files are allowed.\nMaximum size: 10MB.\n\n',
            upload_image_length_error : 'You can only upload 10 images at a time.',
            youtube_choose:      'Youtube',
        }
}

module.exports = {
    language
};